import { render, staticRenderFns } from "./GlobalSpecs.vue?vue&type=template&id=3626878c&"
import script from "./GlobalSpecs.vue?vue&type=script&lang=js&"
export * from "./GlobalSpecs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports